import { ResponsiveBar } from '@nivo/bar';
import { useEffect, useState } from 'react';
import Button from '../../components/Button';

const BarChart = ({ data, regions, ageGroups }) => {
  const [reset, setReset] = useState(false);
  const [keys, setKeys] = useState(ageGroups.map((age) => 'Vek ' + age.value));
  const regionNames = regions.map((region) => region.value);

  useEffect(() => {
    setKeys(ageGroups.map((age) => 'Vek ' + age.value));
  }, [ageGroups]);

  const reverseData = () => {
    setKeys(keys.reverse());
    setReset(!reset);
  };

  const isSingleDay = data.length === 8;

  return (
    <>
      <Button onClick={reverseData}>Otočiť dáta</Button>
      <ResponsiveBar
        key={Boolean(reset)}
        data={data.filter((region) =>
          regionNames.includes(region.region.split(' ')[0])
        )}
        keys={keys}
        indexBy="region"
        margin={{
          top: 25,
          right: 100,
          bottom: 90,
          left: isSingleDay ? 100 : 160,
        }}
        padding={0.3}
        layout="horizontal"
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={[
          '#a6cee3',
          '#1f78b4',
          '#b2df8a',
          '#33a02c',
          '#fb9a99',
          '#e31a1c',
          '#fdbf6f',
          '#ff7f00',
          '#cab2d6',
          '#6a3d9a',
          '#ffff99',
          '#b15928',
          '#bcbd22',
          '#17becf',
          '#666',
          '#E238EC',
        ]}
        enableGridX={true}
        borderColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        axisTop={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
        }}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Počet ľudí v čakárni',
          legendPosition: 'middle',
          legendOffset: 45,
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Kraj',
          legendPosition: 'middle',
          legendOffset: isSingleDay ? -80 : -150,
        }}
        labelSkipWidth={12}
        labelSkipHeight={12}
        labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
        legends={[
          {
            dataFrom: 'keys',
            anchor: 'bottom-right',
            direction: 'column',
            justify: false,
            translateX: 120,
            translateY: 0,
            itemsSpacing: 2,
            itemWidth: 100,
            itemHeight: 20,
            itemDirection: 'left-to-right',
            itemOpacity: 0.85,
            symbolSize: 20,
            effects: [
              {
                on: 'hover',
                style: {
                  itemOpacity: 1,
                },
              },
            ],
          },
        ]}
        animate={true}
        motionStiffness={90}
        motionDamping={15}
      />
    </>
  );
};

export default BarChart;
